import { HTTP_CLIENT } from '@common/clients/http/http.client.interface';
import { AUTH_SERVICE } from '@common/services/auth/auth.service.interface';
import { LOG_SERVICE } from '@common/services/log/log.service.interface';
import HttpClient from '@scoring-web/clients/http/http.client';
import AuthService from '@scoring-web/services/auth/auth.service';
import LogService from '@scoring-web/services/log/log.service';
import { container } from 'tsyringe';

container.registerInstance(LOG_SERVICE, new LogService());

container.registerInstance(AUTH_SERVICE, new AuthService());

container.registerInstance(HTTP_CLIENT, new HttpClient());
